/**
 * Onboarding related types
 * Re-exported from shared types for compatibility
 */

export type { OnboardingFormData, OnboardingState } from '../../shared/types';

export { OnboardingStep } from '../../shared/types';
